import React from "react";
import { Position, Toaster, Toast } from "@blueprintjs/core";

export const AppToaster = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
});
